
import React, { Component } from 'react';
import { Modal, Form, Input, Row, Col, Divider, Select, Switch, Descriptions, Icon } from 'antd';


import { calculationTax } from './taxTicket.js';

import http from '../../../axios/http';
// import validator from '../../../util/validator';

import messager from '../../ui/messager';

import '../../../style/common/uploadImage.css';

import { checkIdNo } from '../../../util/util.js'

const FormItem = Form.Item;

const commonFiled = [{
    "text": "填票人",
    "field": "filler"
}, {
    "text": "税务机关",
    "field": "taxAuthorities"
}, {
    "text": "作为税票基准号",
    "field": "updateMaxTaxNo",
    "radio": true
}];

const seller = [{
    "text": "纳税类型",
    "field": "sellerType",
    select: true,
    dictList: [{
        code: 1,
        name: '个人'
    }, {
        code: 2,
        name: '小规模'
    }, {
        code: 3,
        name: '一般纳税人'
    }, {
        code: 4,
        name: '一般纳税人-固定资产'
    }]
}, {
    "text": "纳税人识别号",
    "field": "sellerCreditNo",
    "label": true
}, {
    "text": "纳税人名称",
    "field": "sellerName",
    "label": true
}, {
    "text": "纳税人地址",
    "field": "sellerAddr",
    "label": true
}, {
    "text": "税票号",
    "field": "sellerTaxNo"
}, {
    "text": "交易票号",
    "field": "invoiceNo",
    "label": true
}];

const buyer = [{
    "text": "纳税类型",
    "field": "buyerType",
    select: true,
    dictList: [{
        code: 1,
        name: '个人'
    }, {
        code: 2,
        name: '小规模'
    }, {
        code: 3,
        name: '一般纳税人'
    }]
}, {
    "text": "纳税人识别号",
    "field": "buyerCreditNo",
    "label": true
}, {
    "text": "纳税人名称",
    "field": "buyerName",
    "label": true
}, {
    "text": "纳税人地址",
    "field": "buyerAddr",
    "label": true
}, {
    "text": "税票号",
    "field": "buyerTaxNo"
}, {
    "text": "交易票号",
    "field": "invoiceNo",
    "label": true
}];

class TaxEditForm extends Component {

    state = {
        sellerTax: {},
        buyerTax: {},
        taxpayerRecord: {},

        taxQueryVisible: true,
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    // componentWillReceiveProps(that){
    //     if(that.visible){
    //         this.initCalculation(that.editData);
    //     }
    // }

    initCalculation = (editData) => {
        let sellerTax = calculationTax(true, editData.sellerType, editData.amount);
        // let buyerTax = calculationTax(false, editData.buyerType, editData.amount);
        let taxQueryVisible = checkIdNo(editData.sellerCreditNo);

        // this.setState({ sellerTax: sellerTax, buyerTax: buyerTax, taxQueryVisible: taxQueryVisible });
        this.setState({ sellerTax: sellerTax, taxQueryVisible: taxQueryVisible });

        this.queryTaxpayerType(0, editData.sellerCreditNo);
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values.id = this.props.editData.id;
            values["updateMaxTaxNo"] = values["updateMaxTaxNo"] === true ? 1 : 0;

            http.post({
                url: '/taxTicket/saveTaxTicket',
                data: values,
                success: (res) => {
                    if (this.props.successCallback) {
                        this.props.successCallback(this.props.queryData);
                    }
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    createDom = (data) => {
        let dom = [];
        for (let i = 0; i < data.length; i += 2) {
            let item = (<Row key={i}>
                <Col span={11}>
                    {this.createDomItem(data[i])}
                </Col>
                <Col span={11} offset={2}>
                    {(i + 1) < data.length ? this.createDomItem(data[i + 1]) : ''}
                </Col>
            </Row>);
            dom.push(item);
        }
        return dom;
    };
    createDomItem = (item) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        return (
            <FormItem label={item.text + "："}>
                {
                    getFieldDecorator(item.field, {
                        rules: item.rules,
                        initialValue: editData[item.field],
                        valuePropName: item.radio ? 'checked' : 'value'
                    })(
                        item.select ?
                            <Select onSelect={this.onSelect.bind(this, item.field)} >
                                {item.dictList.map(d => <Select.Option key={d["code"]}>{d["name"]}</Select.Option>)}
                            </Select>
                            : item.radio ?
                                <Switch checkedChildren="是" unCheckedChildren="否" />
                                : item.label ? <span>{editData[item.field]}</span>
                                    : <Input disabled={item.disabled === true} />
                    )
                }
            </FormItem>
        );
    }

    onSelect = (field, key) => {
        if (field === 'sellerType') {
            let sellerTax = calculationTax(true, key, this.props.editData.amount);
            this.setState({ sellerTax: sellerTax });
        }
    }


    //查询纳税人类型
    queryTaxpayerType = (requery, creditNo) => {
        http.get({
            url: '/application/findTaxpaeryType',
            data: {
                requery: requery,
                creditNo: creditNo
            },
            success: (res) => {
                this.setState({ taxpayerRecord: res });
                if (requery === 1) {
                    messager.notify("查询成功！");
                }
            }
        });
    }



    render() {
        const { visible, onCancel, editData } = this.props;
        return (
            <Modal
                width={900}
                visible={visible}
                title="税收缴款编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => {
                    this.props.form.resetFields();
                    this.setState({ taxpayerRecord: null });
                }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <Row style={{ paddingBottom: '10px' }}>
                        <Col span={4}>
                            <label title="车牌号：">车牌号：</label>
                        </Col>
                        <Col span={9}>{editData.plateNo}</Col>
                        <Col span={4}>
                            <label title="车价：">车价：</label>
                        </Col>
                        <Col span={7}>{editData.amount}</Col>
                    </Row>
                    {this.createDom(commonFiled)}
                    <Divider orientation="left">旧车主</Divider>
                    {this.createDom(seller)}
                    <Row>
                        <Col span={4} style={taxTitle}>增值税：</Col>
                        <Col span={4} style={taxValue}>{this.state.sellerTax.addedTax}</Col>
                        <Col span={4} style={taxTitle}>城市维护建设税：</Col>
                        <Col span={4} style={taxValue}>{this.state.sellerTax.constructionTax}</Col>
                        <Col span={4} style={taxTitle}>教育费附加：</Col>
                        <Col span={4} style={taxValue}>{this.state.sellerTax.educationalSurtax}</Col>
                    </Row>
                    <Row>
                        <Col span={4} style={taxTitle}>地方教育附加：</Col>
                        <Col span={4} style={taxValue}>{this.state.sellerTax.localEducationalSurtax}</Col>
                        <Col span={4} style={taxTitle}>印花税：</Col>
                        <Col span={4} style={taxValue}>{this.state.sellerTax.stampTax}</Col>
                        <Col span={4} style={taxTitle}>合计：</Col>
                        <Col span={4} style={taxValue}>{this.state.sellerTax.totalTax}</Col>
                    </Row>
                    {
                        this.state.taxQueryVisible ? "" :
                            <Row style={{ marginTop: "5px" }}>
                                <Col>
                                    <Descriptions title="" bordered column={2}>
                                        <Descriptions.Item label={"上次查询时间："}>{this.state.taxpayerRecord != null ? this.state.taxpayerRecord.insertTime : ""}</Descriptions.Item>
                                        <Descriptions.Item label={"查询结果："}>{
                                            this.state.taxpayerRecord != null ?
                                                { 1: "个人", 2: "小规模", 3: "一般纳税人", 4: "固定资产的一般纳税人" }[this.state.taxpayerRecord.resultType]
                                                : "未查询到数据"
                                        }</Descriptions.Item>
                                        <Descriptions.Item label={"状态："}>{this.state.taxpayerRecord != null ? this.state.taxpayerRecord.status : ""}</Descriptions.Item>
                                        <Descriptions.Item label={"重新查询："}>
                                            <Icon type="search" className="table-operate-icon"
                                                style={{ color: '#1890ff' }}
                                                onClick={this.queryTaxpayerType.bind(this, 1, editData["sellerCreditNo"])} />
                                        </Descriptions.Item>
                                    </Descriptions>
                                </Col>
                            </Row>
                    }
                    <Divider orientation="left">新车主</Divider>
                    {this.createDom(buyer)}
                    {/* <Row>
                        <Col span={4} style={taxTitle}>印花税：</Col>
                        <Col span={12} style={taxValue}>{this.state.buyerTax.stampTax}</Col>
                        <Col span={4} style={taxTitle}>合计：</Col>
                        <Col span={4} style={taxValue}>{this.state.buyerTax.totalTax}</Col>
                    </Row> */}
                </Form>
            </Modal>
        );
    }
}

const taxTitle = {
    fontWeight: 'bold'
}

const taxValue = {
    color: '#ff0000'
}

const TaxEdit = Form.create()(TaxEditForm);

export default TaxEdit;